// DistributaryForm.tsx
import Add from "../../table/Add";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { addDistributaryTitle, distributaryZone } from "../../../constants";
const DistributaryForm = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data: any) => {
    try {
        const distributaryData = {
            Distributary_zone: data.Distributary_Zone,
            TotalArea: data.TotalArea
        }

      const response = await ApiService.axiosApi('/dzone', {
        method: 'POST',
        data: distributaryData
      });

      if (response.success) {
        toast.success("Distributary added successfully");
        navigate(-1);
      } else {
        toast.error(response.data.message || "Failed to add distributary");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to add distributary");
    }
  };

  return (
    <>
     <Add
       title={addDistributaryTitle}
       parentTitle = {distributaryZone}
       onSubmit = {onSubmit}
       fields = {[
        {
          name : "Distributary_Zone",
          label : "Distributary Zone",
          type: "text",
          validation :  { required: "Distributary Zone is required" }
        },
        {
           name : "TotalArea",
           label:"Total Area",
           type : "text",
           validation :  { required: "Toatal Area is required" }
        }
       ]}
     />
    </>
  );
};

export default DistributaryForm;